import React, { useEffect, useState, useImperativeHandle } from 'react';
import styles from './index.module.scss';
let savedRange = null;

const Text = ({clickTag, defaultValue,onChange, cRef}) => {

  const [initValue,setInitValue] = useState('');

  /**
   * 获取节点
   * @param text
   * @returns {*}
   */
  const getNode= (text)  =>{
    let node = document.createElement('SPAN');
    node.innerText = text;
    node.style = 'cursor:default;-webkit-user-modify:read-only!important;color:#3399FF;';
    return node;
  }

  /**
   * 增加节点
   * @param node
   */
  const insertNode= (node) => {
    savedRange?.deleteContents();
    savedRange?.insertNode(node);
  }

  /**
   * 添加标签
   * @param text
   */
  const addTag = (text) => {
    if(savedRange?.commonAncestorContainer?.parentElement?.id == 'myInput') {
      let node = getNode(text);
      insertNode(node);
      let txt = formatText(savedRange?.commonAncestorContainer.innerText);
      onChange(txt);
    }
  }

  const onKeyUp = (e) =>{
    const txt  = formatText(e.target.innerText);
    onChange(txt);
    e.preventDefault();
  }

  const formatText = (text) =>{
    return text;
  }

  const setDefaultValue = () => {
    const text = defaultValue?.replace(/#[^#]+#/gi, (word) => {
      return getNode(word).outerHTML;
    });
    setInitValue(text);
  }
  useImperativeHandle(cRef, () => ({
    // changeVal 就是暴露给父组件的方法
    cleanText: (newVal) => {
      setInitValue('');
      document.getElementById('myInput').innerHTML = '';
    },
    setInit: () => {
      debugger
      console.log(defaultValue,'defaultValue')
      setDefaultValue();
      onChange(defaultValue);
    }
  }));
  useEffect(()=>{
    document.addEventListener('selectionchange', (event) => {
      const sel = window.getSelection();
      const range = sel.rangeCount > 0 ? sel.getRangeAt(0) : null;
      //如果当前元素是我的富文本
      if (range && range.commonAncestorContainer.ownerDocument.activeElement.id === 'myInput') {
        savedRange = range;
      }
    });
    setDefaultValue();
  },[])

  useEffect(()=>{
    if(clickTag.key) {
      addTag(` ${clickTag.value} `);
    }
  },[clickTag])

  return (
     <div id="myInput" className={`${styles.tagTextArea}`} onKeyUp={onKeyUp} dangerouslySetInnerHTML = {{__html:`${initValue}`}} ></div>
  )
}
export default Text;
